import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserFilter } from "src/app/components/user-filter/user-filter";
import { DataService } from "../data.service";

@Injectable({
  providedIn: "root",
})
export class UserFilterService {
  constructor(private dataService: DataService) {}
  private readonly baseUrl: string = "/UserFilter";

  async getByUserAndComponent(
    userId: number,
    component: string,
  ): Promise<UserFilter> {
    return await this.dataService
      .get<UserFilter>(
        `${this.baseUrl}/GetByUserAndComponent?userId=${userId}&component=${component}`,
      )
      .toPromise();
  }

  async save(userFilter: UserFilter): Promise<void> {
    await this.dataService
      .post<void>(`${this.baseUrl}/set`, userFilter)
      .toPromise();
  }
}
